import { combineReducers } from 'redux'

import getCarePlansList from './getCarePlansList'
import createCarePlan from './createCarePlan'
import updateCarePlan from './updateCarePlan'
import deleteCarePlan from './deleteCarePlan'
import discontinueService from './discontinueService'
import getCarePlanVersions from './getCarePlanVersions'

import { slice as getCarePlansListSlice } from './getCarePlansList'
import { slice as createCarePlanSlice } from './createCarePlan'
import { slice as updateCarePlanSlice } from './updateCarePlan'
import { slice as deleteCarePlanSlice } from './deleteCarePlan'
import { slice as discontinueServiceSlice } from './discontinueService'
import { slice as getCarePlanVersionsSlice } from './getCarePlanVersions'

const carePlansRootReducer = combineReducers({
  ...getCarePlansList,
  ...createCarePlan,
  ...updateCarePlan,
  ...deleteCarePlan,
  ...discontinueService,
  ...getCarePlanVersions
})

export const carePlanSagas = [
  ...getCarePlansListSlice.sagas,
  ...createCarePlanSlice.sagas,
  ...updateCarePlanSlice.sagas,
  ...deleteCarePlanSlice.sagas,
  ...discontinueServiceSlice.sagas,
  ...getCarePlanVersionsSlice.sagas
]

export const carePlanActions = {
  ...getCarePlansListSlice.actions,
  ...createCarePlanSlice.actions,
  ...updateCarePlanSlice.actions,
  ...deleteCarePlanSlice.actions,
  ...discontinueServiceSlice.actions,
  ...getCarePlanVersionsSlice.actions
}

export default carePlansRootReducer
